<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH DÒNG HỌ</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
          </div>
        </div>

        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <div class="main-body-search-form" style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Tên dòng họ">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['ten']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                          placeholder="Nhập tên dòng họ"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Tên đại lý">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['dai_ly_id']
                          "
                          filterable
                          placeholder="Chọn tên đại lý"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in listDaiLy"
                            :key="item.id"
                            :label="item.ten"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Số điện thoại">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value[
                              'nguoi_quan_lys.dien_thoai'
                            ]
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                          placeholder="Nhập số điện thoại"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Hiệu lực">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['hieu_luc']
                          "
                          filterable
                          placeholder="Chọn hiệu lực"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in mData.hieuLuc"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Trạng thái">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['trang_thai']
                          "
                          filterable
                          placeholder="Chọn trạng thái"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in mData.trangThai"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Gói dịch vụ">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value[
                              'goi_dich_vu.goi_dich_vu_id'
                            ]
                          "
                          filterable
                          placeholder="Chọn gói dịch vụ"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in listGoiDichVu"
                            :key="item.id"
                            :label="item.ten"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              stripe
              :row-class-name="tableRowClassName"
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column prop="" label="STT" width="50" fixed>
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                fixed
                prop="ten"
                label="Tên dòng họ"
                min-width="200"
                :sortable="mData.tableRules.allowSorting"
              >
              </el-table-column>
              <el-table-column prop="dia_chi_full" label="Địa chỉ" width="350">
                <template slot-scope="scope">
                  <el-tooltip effect="dark" placement="top">
                    <div slot="content">{{ scope.row.dia_chi_full }}</div>
                    <span>{{ scope.row.dia_chi_full }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="nguoi_quan_lys[0].dien_thoai"
                label="Số điện thoại"
                align="center"
                width="150"
              >
              </el-table-column>
              <el-table-column
                label="Đại lý hỗ trợ"
                align="center"
                width="150"
              >
                <template slot-scope="scope">
                  <router-link
                    :to="`/admin/dai-ly/chi-tiet/${scope.row.dai_ly_id}`"
                    >{{ scope.row.ten_dai_ly }}</router-link
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="Đại lý khởi tạo"
                align="center"
                width="150"
              >
                <template slot-scope="scope">
                  <router-link
                    :to="`/admin/dai-ly/chi-tiet/${scope.row.dai_ly_khoi_tao_id}`"
                    >{{ scope.row.ten_dai_ly_khoi_tao }}</router-link
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="trang_thai"
                label="Trạng thái"
                align="center"
                width="160"
              >
                <template slot-scope="scope">
                  <p
                    class="status-dong-ho"
                    :class="{
                      chua_thanh_toan:
                        scope.row.trang_thai === 'chua_thanh_toan',
                      cho_gia_han: scope.row.trang_thai === 'cho_gia_han',
                      sap_het_han: scope.row.trang_thai === 'sap_het_han',
                      dang_hoat_dong: scope.row.trang_thai === 'dang_hoat_dong',
                    }"
                  >
                    {{ fn_renderStatus(scope.row.trang_thai) }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                prop="thoi_diem_tao"
                label="Thời điểm đăng kí"
                align="center"
                width="160"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  <div class="text-center">
                    {{
                      fn_date(scope.row.thoi_diem_tao),
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="so_node"
                label="Số node"
                align="center"
                width="100"
              >
                <template slot-scope="scope">
                  <div class="text-center">
                    {{
                      scope.row.so_node,
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="200px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-link
                    :href="scope.row.urlDetailLink"
                    :underline="false"
                    style="margin: 0 3px 0"
                    ><el-button
                      size="mini"
                      plain
                      @click="fn_handle('detail', scope.$index, scope.row)"
                      v-b-popover.hover.left="aLang.c_detail"
                    >
                      <i class="fa fa-eye"></i> </el-button
                  ></el-link>
                  <el-link
                    :href="scope.row.urlRegisterLink"
                    :underline="false"
                    style="margin: 0 3px 0"
                    ><el-button
                      size="mini"
                      plain
                      @click="fn_handle('register', scope.$index, scope.row)"
                      type="link"
                      v-b-popover.hover.left="aLang.c_register"
                    >
                      <i class="fa-solid fa-registered"></i> </el-button
                  ></el-link>
                  <el-link
                    :href="scope.row.urlUpdateLink"
                    :underline="false"
                    style="margin: 0 3px 0"
                    ><el-button
                      size="mini"
                      plain
                      @click="fn_handle('update', scope.$index, scope.row)"
                      type="primary"
                      v-b-popover.hover.left="aLang.c_update"
                    >
                      <i class="far fa-edit"></i> </el-button
                  ></el-link>
                  <el-button
                    size="mini"
                    plain
                    v-ladda
                    @click="fn_handle('check', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_check"
                    type="warning"
                    :id="scope.row.id + '_check_status'"
                    v-if="scope.row.checkStatus"
                  >
                    <i class="fa-solid fa-check-to-slot"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    v-b-popover.hover.left="aLang.c_check_ok"
                    type="success"
                    v-if="scope.row.checkOk"
                  >
                    <i class="fa-solid fa-circle-check"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    v-b-popover.hover.left="aLang.c_check_error"
                    type="danger"
                    v-if="scope.row.checkError"
                    @click="fn_showLaiLoiDongHo(scope, scope.row)"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div
              class="mt-2 d-flex justify-content-between"
              v-if="mData.tableRules.allowPaging"
            >
              <el-button
                type="danger"
                icon="el-icon-check"
                @click="fn_kiemTraDuLieuDongHo('arrayIdDongHo')"
                >Kiểm tra dữ liệu dòng họ</el-button
              >
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>

            <el-dialog
              title="THÔNG TIN KIỂM TRA DỮ LIỆU DÒNG HỌ"
              :visible.sync="dialogKiemTraDuLieuDongHo"
              style="max-height: 720px"
            >
              <el-table
                :data="dataKiemTraDuLieuDongHo"
                v-loading="loadingTableKiemTraDuLieuDongHo"
                border
              >
                <el-table-column prop="" label="STT" width="100">
                  <template slot-scope="scope">
                    <div class="text-center">
                      {{ scope.$index + 1 }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  property="tenDongHo"
                  label="Tên dòng họ"
                  min-width="300"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="Xem chi tiết"
                  align="center"
                  width="150px"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      plain
                      @click="fn_showLoiDongHo(scope, scope.row)"
                    >
                      <i class="fa fa-eye"></i>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-dialog>
            <el-dialog
              title="Lỗi thành viên trong dòng họ chi tiết"
              :visible.sync="dialogLoiDuLieuDongHoChiTiet"
              class="dialog-error"
            >
              <span style="white-space: pre-line">{{ message }}</span>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormDongHo";
import mushroom from "viettoc-api";
import moment from "moment";

export default {
  data() {
    return {
      khoang_dinh: [
        { value: 100, label: "Dưới 100 đinh" },
        { value: 200, label: "Từ 100 đến 200 đinh" },
        { value: 300, label: "Từ 200 đến 300 đinh" },
        { value: 500, label: "Từ 300 đến 500 đinh" },
        { value: 1000, label: "Từ 500 đến 1000 đinh" },
        { value: 3000, label: "Từ 1000 đến 3000 đinh" },
        { value: 999999, label: "Trên 3000 đinh" },
      ],
      ten_dong_ho: [],
      so_dien_thoai: [],
      listDaiLy: [],
      aLang: LanguageService.lang,
      loading: true,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
        hieuLuc: MethodService.copyObject(DataForm.hieuLuc),
        trangThai: MethodService.copyObject(DataForm.trangThai),
      },
      urlDetail: "", // link mở sang tab mới khi bấm xem chi tiết dòng họ
      urlUpdate: "", // link mở sang tab mới khi bấm cập nhật dòng họ
      urlRegister: "", // link mở sang tab mới khi bấm xem link đăng ký dòng họ
      arrayIdDongHo: [], // mảng các id dòng họ theo phân trang để kiểm tra dữ liệu dòng họ
      listGoiDichVu: [],
      dialogKiemTraDuLieuDongHo: false,
      dataKiemTraDuLieuDongHo: [],
      loadingTableKiemTraDuLieuDongHo: true,
      dialogLoiDuLieuDongHoChiTiet: false,
      message: "", // lỗi dữ liệu dòng họ
    };
  },
  components: {
    Circle4,
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.hieu_luc === false) {
        return "textLine";
      }
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields: this.mData.tableRules.fields,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
        dataFilter.filters = this.mData.tableRules.filters;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachDongHo",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      try {
        const response = await mushroom.dong_ho.listAsync(dataFilter);
        if (response.result) {
          response.result.forEach((item) => {
            item.dia_chi_full = "";
            item.so_node = ""; // thêm cột số node kích hoạt/được duyệt
            item.ho_so_dang_ky_dong_ho_id = "";
            item.urlDetailLink = ""; // link để dùng khi bấm chuột phải new tab
            item.urlUpdateLink = ""; // link để dùng khi bấm chuột phải new tab
            item.urlRegisterLink = ""; // link để dùng khi bấm chuột phải new tab
          });
          console.log("thong tin dong ho", response.result);
          // lấy mảng 10 id dòng họ để kiểm tra dữ liệu dòng họ
          this.arrayIdDongHo = [];
          response.result.forEach((item) => this.arrayIdDongHo.push(item.id));
          console.log("this.arrayIdDongHo", this.arrayIdDongHo);
          let res = await this.fn_changedata(response.result);
          this.mData.tableRules.data = res;
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
          this.loading = false;
        }
      } catch (e) {
        console.log(e);
        if (e.code === 4) {
          this.loading = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.loading = false;
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
    },
    async fn_getAllDaiLy() {
      try {
        const response = await mushroom.agt_dai_ly.getAllAsync({ limit: 100 });
        console.log("Các agt_dai_ly thỏa mãn: %o", response);
        if (response.result) this.listDaiLy = response.result;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_getAllGoiDichVu() {
      try {
        const response = await mushroom.prd_goi_dich_vu.getAllAsync({
          limit: 100,
        });
        console.log("Các goi_dich_vu thỏa mãn: %o", response);
        if (response.result) this.listGoiDichVu = response.result;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    fn_renderStatus(status) {
      return MethodService.renderStatus(status);
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },
    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      this.mData.tableRules.dataSearch.value["ten"] = "";
      this.mData.tableRules.dataSearch.value["dia_chi.dia_chi"] = "";
      this.mData.tableRules.dataSearch.value["dai_ly_id"] = "";
      this.mData.tableRules.dataSearch.value["nguoi_quan_lys[0].dien_thoai"] =
        "";
      this.mData.tableRules.filters = "";
      this.$router.replace({
        name: "DanhSachDongHo",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable();
    },
    fn_date(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    async fn_changedata(data) {
      data.forEach(async (item) => {
        item.ten_dai_ly = "";
        this.listDaiLy.forEach((itemListDaiLy) => {
          if (itemListDaiLy.id === item.dai_ly_id)
            item.ten_dai_ly = itemListDaiLy.ten;
        });
        item.ten_dai_ly_khoi_tao = ""
        this.listDaiLy.forEach((itemListDaiLy) => {
          if (itemListDaiLy.id === item.dai_ly_khoi_tao_id)
            item.ten_dai_ly_khoi_tao = itemListDaiLy.ten;
        });
        item.checkOk = false;
        item.checkError = false;
        item.checkStatus = true;
        item.message = "";
        // -- lấy link để new tab --
        item.urlDetailLink =
          location.origin +
          this.$router.resolve({
            name: "ChiTietDongHo",
            params: { id: item.id },
          }).href;
        item.urlUpdateLink =
          location.origin +
          this.$router.resolve({
            name: "CapNhatDongHo",
            params: { id: item.id },
          }).href;
        // lấy id của dòng họ đăng ký phục vụ cho link tới bản đăng ký của dòng họ đó
        const responseIdDongHoDangKy = await mushroom.dang_ky.listAsync({
          fields:
            "id,ten_dong_ho,quoc_gia_id,tinh_id,huyen_id,xa_id,dia_chi,khoang_dinh,xung_ho,ho_ten,trong_ho,dien_thoai,email,trang_thai,li_do_tu_choi,thoi_diem_tao,thoi_diem_cap_nhat,dong_ho_id,thoi_diem_xet_duyet,nguoi_xet_duyet",
          filters: ["dong_ho_id=" + item.id],
        });

        item.urlRegisterLink =
          location.origin +
          this.$router.resolve({
            name: "DuyetDangKyDongHo",
            params: { id: responseIdDongHoDangKy.result[0].id },
          }).href;
        // -- end --

        item.nguoi_quan_lys[0].dien_thoai = MethodService.formatPhone(
          item.nguoi_quan_lys[0].dien_thoai
        );
        // lấy thông tin node được duyệt và kích hoạt của từng dòng họ
        const responseNodeTypeKichHoat = await mushroom.node_gia_pha.listAsync({
          filters: ["dong_ho_id=" + item.id, "kich_hoat=true"],
          fields: "kich_hoat",
          limit: 1,
        });
        const responseNodeTypeDuocDuyet = await mushroom.node_gia_pha.listAsync(
          {
            filters: ["dong_ho_id=" + item.id, "duoc_duyet=true"],
            fields: "duoc_duyet",
            limit: 1,
          }
        );
        item.so_node =
          responseNodeTypeKichHoat.meta.total +
          "/" +
          responseNodeTypeDuocDuyet.meta.total;
        let diachi = item.dia_chi.dia_chi;
        let responseTinh = "";
        let responseHuyen = "";
        let responseXa = "";

        if (
          item.dia_chi.quoc_gia_id &&
          item.dia_chi.quoc_gia_id !== "5d897ee10192751324184dda"
        ) {
          try {
            const response = await mushroom.quoc_gia.findByIdAsync({
              id: item.dia_chi.quoc_gia_id,
            });
            console.log("Thông tin quoc_gia trả về: %o", response);
            if (response.result && response.result.ma.alpha_2 !== "VN")
              diachi = diachi + ", " + response.result.ten_quoc_gia.vi;
          } catch (e) {
            console.error("Có lỗi: %o", e);
          }
        }

        if (
          !item.dia_chi.quoc_gia_id ||
          item.dia_chi.quoc_gia_id === "5d897ee10192751324184dda"
        ) {
          if (item.dia_chi.xa_id) {
            responseXa = await mushroom.commune.findByIdAsync({
              id: item.dia_chi.xa_id,
            });
            diachi =
              diachi +
              ", " +
              responseXa.result.type +
              " " +
              responseXa.result.name;
          }
          if (item.dia_chi.huyen_id) {
            responseHuyen = await mushroom.district.findByIdAsync({
              id: item.dia_chi.huyen_id,
            });
            diachi =
              diachi +
              ", " +
              responseHuyen.result.type +
              " " +
              responseHuyen.result.name;
          }
          if (item.dia_chi.tinh_id) {
            responseTinh = await mushroom.province.findByIdAsync({
              id: item.dia_chi.tinh_id,
            });
            diachi =
              diachi +
              ", " +
              responseTinh.result.type +
              " " +
              responseTinh.result.name;
          }
        }

        item.dia_chi_full = diachi;

        if (item.khoang_dinh.tu == 1 || item.khoang_dinh.den == 100) {
          item.khoang_dinh.den = "Dưới 100 đinh";
        } else if (item.khoang_dinh.tu == 100) {
          item.khoang_dinh.den = "Từ 100 đến 200 đinh";
        } else if (item.khoang_dinh.tu == 200) {
          item.khoang_dinh.den = "Từ 200 đến 300 đinh";
        } else if (item.khoang_dinh.tu == 300) {
          item.khoang_dinh.den = "Từ 300 đến 500 đinh";
        } else if (item.khoang_dinh.tu == 500) {
          item.khoang_dinh.den = "Từ 500 đến 1000 đinh";
        } else if (item.khoang_dinh.tu == 1000) {
          item.khoang_dinh.den = "Từ 1000 đến 3000 đinh";
        } else if (item.khoang_dinh.tu >= 3000) {
          item.khoang_dinh.den = "Trên 3000 đinh";
        }
      });
      return data;
    },
    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      this.$router.replace({
        name: "DanhSachDongHo",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable(this.mData.tableRules.filters);
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["ten"]) {
        this.mData.tableRules.dataSearch.value["ten"] =
          this.mData.tableRules.dataSearch.value["ten"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["dia_chi.dia_chi"]) {
        this.mData.tableRules.dataSearch.value["dia_chi.dia_chi"] =
          this.mData.tableRules.dataSearch.value["dia_chi.dia_chi"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["nguoi_quan_lys.dien_thoai"]) {
        if (
          this.mData.tableRules.dataSearch.value[
            "nguoi_quan_lys.dien_thoai"
          ].slice(0, 1) == 0
        ) {
          this.mData.tableRules.dataSearch.value["nguoi_quan_lys.dien_thoai"] =
            "84" +
            this.mData.tableRules.dataSearch.value[
              "nguoi_quan_lys.dien_thoai"
            ].slice(1, 10);
        } else {
          this.mData.tableRules.dataSearch.value["nguoi_quan_lys.dien_thoai"] =
            this.mData.tableRules.dataSearch.value[
              "nguoi_quan_lys.dien_thoai"
            ].trim();
        }
      }

      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          console.log(this.mData.tableRules.filters);
          this.fn_initTable();
          MethodService.stopLadda();
          if (
            this.mData.tableRules.dataSearch.value[
              "nguoi_quan_lys.dien_thoai"
            ] &&
            this.mData.tableRules.dataSearch.value[
              "nguoi_quan_lys.dien_thoai"
            ].slice(0, 2) == 84
          ) {
            this.mData.tableRules.dataSearch.value[
              "nguoi_quan_lys.dien_thoai"
            ] =
              "0" +
              this.mData.tableRules.dataSearch.value[
                "nguoi_quan_lys.dien_thoai"
              ].slice(2, 12);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    // xem chi tiết, xóa bảng
    async fn_handle(type, scope, row) {
      if (type == "detail") {
        this.urlDetail =
          location.origin +
          this.$router.resolve({
            name: "ChiTietDongHo",
            params: { id: row.id },
          }).href;
      }
      if (type == "update") {
        this.urlUpdate =
          location.origin +
          this.$router.resolve({
            name: "CapNhatDongHo",
            params: { id: row.id },
          }).href;
      }
      if (type == "register") {
        // lấy id của dòng họ đăng ký phục vụ cho link tới bản đăng ký của dòng họ đó
        const responseIdDongHoDangKy = await mushroom.dang_ky.listAsync({
          fields:
            "id,ten_dong_ho,quoc_gia_id,tinh_id,huyen_id,xa_id,dia_chi,khoang_dinh,xung_ho,ho_ten,trong_ho,dien_thoai,email,trang_thai,li_do_tu_choi,thoi_diem_tao,thoi_diem_cap_nhat,dong_ho_id,thoi_diem_xet_duyet,nguoi_xet_duyet",
          filters: ["dong_ho_id=" + row.id],
        });

        this.urlRegister =
          location.origin +
          this.$router.resolve({
            name: "DuyetDangKyDongHo",
            params: { id: responseIdDongHoDangKy.result[0].id },
          }).href;
      }
      if (type == "check") {
        this.fn_kiemTraDuLieuDongHo("IdDongHo", row.id, row);
      }
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_addFamily() {
      this.$router.push({
        name: "ThemDongHo",
      });
    },
    async fn_kiemTraDuLieuDongHo(idType, row, rowData) {
      let bodyKiemTraDuLieuDongHo = {
        dong_ho_ids: [],
      };
      if (idType === "arrayIdDongHo") {
        bodyKiemTraDuLieuDongHo.dong_ho_ids = this.arrayIdDongHo;
        this.loadingTableKiemTraDuLieuDongHo = true;
        this.dataKiemTraDuLieuDongHo = [];
        this.dialogKiemTraDuLieuDongHo = true;
        this.fn_kiemTraDuLieuDongHoApi(
          "arrayIdDongHo",
          bodyKiemTraDuLieuDongHo,
          rowData
        );
      } else {
        bodyKiemTraDuLieuDongHo.dong_ho_ids = [row];
        this.fn_kiemTraDuLieuDongHoApi(
          "IdDongHo",
          bodyKiemTraDuLieuDongHo,
          rowData
        );
        // this.fn_showLoiDongHo();
      }
      console.log("bodyKiemTraDuLieuDongHo", bodyKiemTraDuLieuDongHo);
    },
    async fn_kiemTraDuLieuDongHoApi(type, data, rowData) {
      try {
        const response = await mushroom.dong_ho.kiemTraDuLieuDongHoAsync({
          body: data,
        });
        console.log("Dữ liệu dòng họ kiểm tra", response);
        if (type === "arrayIdDongHo") {
          if (response.result.length > 0) {
            let res = this.fn_changeDataKiemTraDongHo(response.result);
            this.dataKiemTraDuLieuDongHo = res;
          } else {
            this.loadingTableKiemTraDuLieuDongHo = false;
            this.dialogLoiDuLieuDongHoChiTiet = false;
            this.dialogKiemTraDuLieuDongHo = false;
            window.toastr.success("Không phát hiện ra lỗi dữ liệu!");
          }
        } else {
          if (response.result.length > 0) {
            response.result[0].detail.forEach((item) => {
              this.dialogLoiDuLieuDongHoChiTiet = true;
              this.message = "";
              this.message +=
                "- " +
                item.ho_ten +
                " " +
                `(${item.node_gia_pha_id})` +
                ". Lỗi: " +
                item.messages.join(",") +
                "\n";
            });
            rowData.checkStatus = false;
            setTimeout(() => {
              rowData.checkError = true;
            }, 100);
            rowData.message = this.message;
          } else {
            window.toastr.success("Không phát hiện ra lỗi dữ liệu!");
            setTimeout(() => {
              rowData.checkOk = true;
            }, 10);
            rowData.checkStatus = false;
          }
        }
      } catch (e) {
        MethodService.showError(e.code);
        this.loadingTableKiemTraDuLieuDongHo = false;
        this.dialogLoiDuLieuDongHoChiTiet = false;
        this.dialogKiemTraDuLieuDongHo = false;
      } finally {
        MethodService.stopLadda();
      }
    },
    fn_changeDataKiemTraDongHo(data) {
      data.forEach(async (item) => {
        item.tenDongHo = "";
        try {
          const response = await mushroom.dong_ho.findByIdAsync({
            id: item.dong_ho_id,
          });
          item.tenDongHo = response.result.ten;
          this.loadingTableKiemTraDuLieuDongHo = false;
        } catch (e) {
          console.error("Có lỗi: %o", e);
        }
      });
      return data;
    },
    fn_showLaiLoiDongHo(scope, row) {
      this.dialogLoiDuLieuDongHoChiTiet = true;
      this.message = row.message;
    },
    fn_showLoiDongHo(scope, row) {
      console.log(row.dong_ho_id);
      this.dialogLoiDuLieuDongHoChiTiet = true;
      this.message = "";
      scope.row.detail.forEach((item) => {
        this.message +=
          "- " +
          item.ho_ten +
          " " +
          `(${item.node_gia_pha_id})` +
          ". Lỗi: " +
          item.messages.join(",") +
          "\n";
      });
    },
  },
  //run after render view
  async created() {
    await this.fn_hashUrl();
    await this.fn_getAllGoiDichVu();
    await this.fn_getAllDaiLy();
    await this.fn_initTable();
  },
};
</script>
<style scoped>
.card {
  min-height: 88vh;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  text-align: center;
  border-radius: 5px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .dialog-error .el-dialog {
  max-height: calc(100% - 100px);
  margin-top: 5vh !important;
  overflow-x: auto;
}
.el-button--link.is-plain {
  color: #ffb69e;
  background: rgba(251, 136, 136, 0.13);
  border-color: #ffb69e;
}

.main-body-search-form {
  height: auto;
  padding: 10px;
}
::v-deep .textLine {
  text-decoration: line-through;
}
@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
</style>
